export enum ProjectStatus {
  PRODUCTION = 'production',
  DRAFT = 'draft',
  WORK_SPACE = 'workspace'
  // IN_PROGRESS = 'in_progress',
}

export interface IStatusConfigModel {
  title: string,
  accepts: string[]
}